import { UpdateUserData, User } from "@/modules/manages/users/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/users"

export const fetchUsers = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchUser = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const createUser = async (data?: User) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updateUser = async (id: string, data?: UpdateUserData) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deleteUser = async (data: UpdateUserData) => {
  try {
    const updatedData = { ...data }
    if (updatedData.password) {
      delete updatedData.password
    }
    if (!updatedData.id) return
    const response = await updateUser(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
